import { PerkDefinition } from "./types";

export const perkAtk = {
  id: "perk_atk",
  name: "Sharper Edge",
  description: "+1 Attack.",
  apply: ({ addAttack }) => {
    addAttack(1);
  },
} satisfies PerkDefinition<"perk_atk">;
